var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9766 1.14844C13.332 1.47656 13.332 2.05078 12.9766 2.37891L5.97656 9.37891C5.64844 9.73438 5.07422 9.73438 4.74609 9.37891L1.24609 5.87891C0.890625 5.55078 0.890625 4.97656 1.24609 4.64844C1.57422 4.29297 2.14844 4.29297 2.47656 4.64844L5.375 7.51953L11.7461 1.14844C12.0742 0.792969 12.6484 0.792969 12.9766 1.14844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.704a7bbd38fe38401e1dc719f1dde7a9.svg";
export { ForwardRef as ReactComponent };